import * as React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { Redirects, Routes as AppRoutes, getNotFoundElement } from './Routes/Routes';
import { ErrorCatcher } from 'layouts/errorCatcher/ErrorCatcher';
import Plain from 'layouts/Plain';
import { BookingNavigationTracker } from 'Routes/BookingNavigationTracker/BookingNavigationTracker';
import { MntnTrackingPixel } from 'Routes/MntnTrackingPixel/MntnTrackingPixel';
import { InitialModal } from 'screens/InitialModals/InitialModal';
import { Maintenance } from 'screens/Maintenance/Maintenance';
import { isMaintenanceModeActive } from 'utilities/maintenanceMode';

import { ScrollToTop } from './ScrollToTop';

export const Router = () => {
  if (isMaintenanceModeActive()) {
    return (
      <BrowserRouter>
        <Plain>
          <ErrorCatcher id="maintenance">
            <Maintenance />
          </ErrorCatcher>
        </Plain>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <InitialModal />
      <BookingNavigationTracker />
      <MntnTrackingPixel />
      <ScrollToTop />
      <Routes>
        {Redirects}
        {AppRoutes.map(route => {
          const { path, Component, Layout } = route;

          return (
            <Route
              key={path}
              path={path}
              element={
                // @ts-ignore
                <Layout>
                  <ErrorCatcher id="route">
                    <Component />
                  </ErrorCatcher>
                </Layout>
              }
            />
          );
        })}
        <Route path="*" element={getNotFoundElement()} />
      </Routes>
    </BrowserRouter>
  );
};
